module.exports = __webpack_public_path__ + "static/img/areaA-9.ac6d08e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント2/areaA-9.png
// module id = 886
// module chunks = 1